import { html, View } from 'rune-ts';
import klass from './TermsModal.module.scss';
import { typo } from '../../../../../shared/typography/typo';

export class TermsModalBody extends View {
  constructor() {
    super({});
  }

  texts = {
    content_title_1: html.preventEscape(ET('mps2::ad_res::terms_modal::content_title_1')),
    content_title_2: html.preventEscape(ET('mps2::ad_res::terms_modal::content_title_2')),
    content_title_3: html.preventEscape(ET('mps2::ad_res::terms_modal::content_title_3')),
    content_title_4: html.preventEscape(ET('mps2::ad_res::terms_modal::content_title_4')),
    content_description_1: html.preventEscape(ET('mps2::ad_res::terms_modal::content_description_1')),
    content_description_2: html.preventEscape(ET('mps2::ad_res::terms_modal::content_description_2')),
    content_description_3: html.preventEscape(ET('mps2::ad_res::terms_modal::content_description_3')),
    content_description_4: html.preventEscape(ET('mps2::ad_res::terms_modal::content_description_4')),
    tip: html.preventEscape(ET('mps2::ad_res::terms_modal::tip')),
  };

  override template() {
    return html`
      <div class="${klass.modal_body}">
        <div class="${klass.modal_content_wrapper}">
          <div class="${klass.modal_content_items}">
            <div class="${klass.modal_content_item}">
              <div class="${klass.content_title} ${typo('12_bold')}">${this.texts.content_title_1}</div>
              <div class="${klass.content_description} ${typo('12_medium')}">
                ${this.texts.content_description_1}
              </div>
            </div>
            <div class="${klass.modal_content_item}">
              <div class="${klass.content_title} ${typo('12_bold')}">${this.texts.content_title_2}</div>
              <div class="${klass.content_description} ${typo('12_medium')}">
                ${this.texts.content_description_2}
              </div>
            </div>
            <div class="${klass.modal_content_item}">
              <div class="${klass.content_title} ${typo('12_bold')}">${this.texts.content_title_3}</div>
              <div class="${klass.content_description} ${typo('12_medium')}">
                ${this.texts.content_description_3}
              </div>
            </div>
            <div class="${klass.modal_content_item}">
              <div class="${klass.content_title} ${typo('12_bold')}">${this.texts.content_title_4}</div>
              <div class="${klass.content_description} ${typo('12_medium')}">
                ${this.texts.content_description_4}
              </div>
            </div>
          </div>

          <div class="${klass.modal_content_tips} ${typo('12_medium')}">${this.texts.tip}</div>
        </div>
      </div>
    `;
  }
}
